/**
 * Find the first pixel where the in-flow tail fits beside the dock.
 * endAt(top) measures the end sentinel with a float occupying [top, top + height].
 * Its tail endAt(top) - top is non-increasing. Layout probes are supplied by the
 * surface; this search owns no DOM, observers or published geometry.
 */
export function chatDockFloatTop({
  endWithoutFloat, height, reachesDock, previous, endAt,
}: {
  endWithoutFloat: number;
  height: number;
  reachesDock: boolean;
  previous: number | null;
  endAt: (top: number) => number;
}): number | null {
  if (!reachesDock || height <= 0 || endWithoutFloat <= 0) return null;
  let low = Math.max(0, Math.floor(endWithoutFloat - height));
  let high = Math.ceil(endWithoutFloat);
  const fits = (top: number): boolean => endAt(top) - top <= height;
  if (previous !== null && previous >= low && previous <= high) {
    const atPrevious = fits(previous);
    if (atPrevious && (previous === low || !fits(previous - 1))) return previous;
    if (atPrevious) high = previous - 1;
    else low = previous + 1;
  }
  // Pixel precision, bounded even for very long transcripts.
  for (let iteration = 0; low < high && iteration < 24; iteration++) {
    const middle = Math.floor((low + high) / 2);
    if (fits(middle)) high = middle;
    else low = middle + 1;
  }
  return high;
}
